@import '@nora-monorepo/ui-shared/lib.css';

@source '../../../../../libs/nora-chat-ui/';
@source '../../../../../libs/ui-shared/';
@source '../../../../../libs/grammar-ui/';

.nora-location-sharing-overlay {
  pointer-events: none !important;
}

.nora-location-sharing-ping {
  width: 44px;
  height: 44px;
  pointer-events: none;
}

.nora-location-sharing-ping[hidden] {
  display: none;
}

.nora-location-sharing-ring {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 4px solid #00c3ff;
  border-radius: 50%;
  opacity: 0.75;
  animation: nora-location-sharing-ping 2s ease-out infinite;
}

@keyframes nora-location-sharing-ping {
  from {
    transform: scale(0.5);
    opacity: 0.75;
  }
  to {
    transform: scale(2);
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .nora-location-sharing-ring {
    animation: none;
  }
}
